import { CellContext } from '@tanstack/react-table';
import { CellLink } from '@/components/table/_fieldDefinitions/_base/CellLink.tsx';
import { CANCELLED_RECORD_CLASS } from '@/components/table/_fieldDefinitions/_base/cancelledRecord.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { cn } from '@/lib/utils.ts';
import { SimpleNestedBooking } from '@/types/SimpleNestedBooking.ts';
import { BookingStatus } from '@/types/BookingStatus.ts';

export const nestedBookingFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as SimpleNestedBooking | null | undefined;
  // jOOQ oddaje zapisującego bez rezerwacji jako obiekt z samymi `null`-ami,
  // nie jako `null` — obie postaci to brak wartości.
  if (!value?.id) return <EmptyValue />;
  const cancelled = value.status === BookingStatus.CANCELLED;
  return (
    <CellLink
      to="/app/bookings/$bookingId/booking"
      params={{ bookingId: value.id }}
      importance={info.column.columnDef.meta?.importance}
      className={cn(cancelled && CANCELLED_RECORD_CLASS)}
    >
      {value.bookingCode}
    </CellLink>
  );
};
